"use client";
import { jsxs, jsx } from 'react/jsx-runtime';
import { getNinjaComponentAttributes } from './common2.js';
import { FormLabel } from './FormLabel2.js';
import styles from './FormInputGroup3.js';

const FormInputGroup = ({ label, isRequired, children, popover, popoverVariant, layoutClassName, reserveLabelSpacing, formId, hasErrors, highlighted, }) => {
    const hasWidth = layoutClassName
        ? Array.isArray(layoutClassName)
            ? layoutClassName.some((c) => c.includes('w-'))
            : layoutClassName.includes('w-')
        : false;
    const hasFlex = layoutClassName
        ? Array.isArray(layoutClassName)
            ? layoutClassName.some((c) => c.includes('flex-'))
            : layoutClassName.includes('flex-')
        : false;
    const labelValue = label ? label : reserveLabelSpacing ? '⁣' : undefined;
    return (jsxs("div", Object.assign({ className: styles.formInputWrapper(hasWidth, hasFlex, layoutClassName, highlighted) }, getNinjaComponentAttributes(formId, hasErrors), { children: [labelValue && (jsx("div", { className: styles.labelWrapper, children: jsx(FormLabel, { isRequired: isRequired, popover: popover, popoverVariant: popoverVariant, children: labelValue }) })), children] })));
};

export { FormInputGroup, FormInputGroup as default };
